module.exports = __webpack_public_path__ + "img/Porto Apartment - 66 of 85.ce07cec1.jpeg";